import { Typography } from "@mui/material";
import type { DateObjectFilter } from "../../api/types/objectTypes";
import { dateFilterOperatorCaptions, getDateFilterValuesText } from "./objectFilterHelpers";

interface Props {
  fieldName: string;
  filter: DateObjectFilter;
  startLabel: string;
}

const ObjectDateFilterDescription = ({ fieldName, filter, startLabel }: Props) => {
  return (
    <Typography>
      {startLabel} <strong>{fieldName}</strong> {dateFilterOperatorCaptions[filter.operator] ?? filter.operator}{" "}
      <strong>{getDateFilterValuesText(filter)}</strong>
    </Typography>
  );
};

export default ObjectDateFilterDescription;
